import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "../assets/styles/component.css"
import { useState } from "react"
import ServiceModal from "./ServiceModal"

export default function SelectorCard(props){

    const [isHovered, setIsHovered] = useState(false)

    const offColor = 'gray-500'
    const onColor = 'blue-500'

    const bkgWhite = isHovered ? '#e0f2fe' : '#ffffff'
    const bkgGrey = isHovered ? '#bae6fd' : '#e5e7eb'

    const [showModal, setShowModal] = useState(false);

    const widthClass = props.isLargeScreen ? 'w-1/3' : 'w-11/12'

    return(
        <>
            <div className={`card-header block ${widthClass} p-3 service-card`}
                style={{...props.style, backgroundColor: `${props.isWhite ? bkgWhite : bkgGrey}`}}
                data-modal-target="medium-modal" data-modal-toggle="medium-modal"
                onMouseOver={() => {setIsHovered(true)}}
                onMouseOut={() => {setIsHovered(false)}}
                onClick={() => {setShowModal(true)}}>
                <FontAwesomeIcon icon={props.icon} style={{paddingRight: "2vw", width: "2.2rem",
                    height: "2.2rem", alignContent: "center", marginTop: "1vh"}}
                    className={`text-${isHovered ? onColor : offColor} service-card`}/>
                <div>
                    <p className={`font-bold text-${isHovered ? onColor : offColor} text-2xl service-card`}
                    style={{alignContent: "center", alignItems: "center"}}>{props.name}</p>
                    <p className={`font-bold text-${isHovered ? onColor : offColor} service-card`}
                        style={{paddingTop: "10px", paddingBottom: "10px", height: props.isLargeScreen ? "60%" : "",
                        textAlign: "justify"
                        }}>
                        {props.resume}
                    </p>
                    <p className={`text-${onColor}`}>Ver Más Detalle</p>
                </div>
                
            </div>
            <ServiceModal showModal={showModal} setShowModal={setShowModal}
                        title={props.name} description={props.description}
                        icon={props.icon} image={props.image}/>
        </>

    )
}